import React from 'react';
import { Panel, BarRow, Big } from './parts';

const pct = (n, d) => (d ? Math.round((n / d) * 1000) / 10 : 0);

export const BracketFunnel = ({ b }) => {
  const s = b.customize_started;
  const rows = [
    ['Started customizing', s, 'started'],
    ['Pressed print or download', b.customize_completed, 'completed'],
    ['Saw the upgrade prompt', b.upgrade_prompt, 'prompt'],
    ['Clicked Upgrade to Pro', b.upgrade_click, 'click'],
    ['Bought Pro afterwards', b.pro_after, 'pro'],
  ];
  return (
    <Panel title="Bracket Library customization" testId="growth-bracket-funnel">
      <div className="grid grid-cols-1 lg:grid-cols-[minmax(0,1fr)_220px] gap-6">
        <div className="flex flex-col gap-3">
          {rows.map(([label, n, k]) => (
            <BarRow key={k} label={label} count={n} pct={pct(n, s)} testId={`growth-bracket-${k}`} />
          ))}
        </div>
        <div className="grid grid-cols-3 lg:grid-cols-1 gap-3">
          <div className="rounded-xl bg-blue-50 p-3"><Big label="Completed" value={`${b.completed_pct}%`} tone="text-[#00247D]" testId="growth-bracket-completed-pct" /></div>
          <div className="rounded-xl bg-red-50 p-3"><Big label="Prompt → click" value={`${b.click_pct}%`} tone="text-[#CF142B]" testId="growth-bracket-click-pct" /></div>
          <div className="rounded-xl bg-amber-50 p-3"><Big label="Start → Pro" value={`${b.pro_pct}%`} tone="text-amber-700" testId="growth-bracket-pro-pct" /></div>
        </div>
      </div>
      <p className="text-xs text-slate-400 mt-4">
        Unique visitors in this period. Bar percentages are out of everyone who started. "Bought Pro afterwards" counts paid Pro purchases made after a customization.
        {b.pro_after_test > 0 && <span data-testid="growth-bracket-test"> {b.pro_after_test} test-mode purchases aren't counted.</span>}
      </p>
    </Panel>
  );
};
